export function DropUploadOverlay() {
  return (
    <div className="pointer-events-none absolute inset-3 z-20 flex items-center justify-center rounded-xl border-2 border-dashed border-emerald-500 bg-ink-950/80">
      <div className="rounded-lg border border-emerald-700 bg-ink-900 px-5 py-4 text-center shadow-xl">
        <div className="text-sm font-semibold text-emerald-200">
          Solte arquivos ou pastas aqui
        </div>
        <div className="mt-1 text-xs text-ink-400">
          PDF, AI, JPEG, PNG e TIFF são aceitos; subpastas vêm junto.
        </div>
      </div>
    </div>
  );
}
